module.exports = __webpack_public_path__ + "img/Darkdoc.231f24b6.svg";